import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import { Box, CircularProgress } from '@mui/material';

export default function ProtectedRoute({
  children,
  requiredScope,
  requiredScopes,
  requireAll = false,
  fallbackPath = '/unauthorized'
}) {
  const { isAuthenticated, isLoading } = useAuth();
  const permissions = usePermissions();
  const location = useLocation();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check permissions if required
  if (requiredScope || requiredScopes) {
    let hasPermission = false;

    if (requiredScope) {
      hasPermission = permissions.hasScope(requiredScope);
    } else if (requiredScopes && requiredScopes.length > 0) {
      hasPermission = requireAll
        ? permissions.hasAllScopes(requiredScopes)
        : permissions.hasAnyScope(requiredScopes);
    }

    if (!hasPermission) {
      return <Navigate to={fallbackPath} state={{ from: location }} replace />;
    }
  }

  return children;
}